<template>
    <div class="" :class="!isPathwayTab ? 'col-12': ''">
      <div class="search-padd">
        <div class="col-xs-12 override-padding" :class="isPathwayTab ? 'd-none': ''">
          <div class="crm_admin_heading enterprise_header text-left"></div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div style="clear: both;" class="margin-bottom-10" :class="isPathwayTab ? 'd-none': ''"></div>
        <form v-on:submit.prevent>
            <div class="row">
                <div class="col-12" v-if="masterAdmin == true">
                    <div class="d-flex justify-content-end">
                      <button
                        :disabled="isSubmit"
                        v-on:click="isModalVisible = true, verrors.clear()"
                        class="btn btn-red btn-group-sm"
                        >
                          <i class="fa fa-plus spacer-icon" aria-hidden="true"></i>
                          <b v-if="!isSubmit">Form</b>
                          <b v-else>Loading...</b>
                      </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="mt-2">
            <div class="col-12 override-padding">
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_1 text-center">&nbsp;</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_2 text-left">Form Name</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_3 text-center"># of Fields</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_4 text-center">Last Updated</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_5 text-center">&nbsp;</div>
            </div>
            <div style="clear: both;"></div>
                <div v-if="formslists.length > 0">
                    <div v-for="(form, index) in formslists" :key="index" class="view_enterprise_accounts">
                        <div class="crm_admin_field_lists enterprise_heading_1 text-center">
                            <span>
                                <input type="checkbox"
                                v-bind:id="'forms_'+index"
                                v-bind:value="form.id"
                                name="forms"
                                v-model="forms_selected">
                            </span>
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_2 text-left">
                            {{ form.name }}
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_3 text-center">
                            {{ form.total_assigned_fields }}
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_4 text-center">
                            {{ form.updatedAt | formatFormUpdatedDate }}
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_5 text-left">
                          <div v-bind:id="'dropdown-container-'+ index" class="dropdown" @click="toggleDropdown('actionDropdown_'+index+'')">
                            <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                              <li></li>
                              <li></li>
                              <li></li>
                            </ul>
                            <div v-bind:id="'actionDropdown_' + index" class="dropdown-content" v-if="!form.publicFlag && form.isPrivateFormEdit">
                              <div v-if="((form.status=='DRAFT' || form.status=='PUBLISH') && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="goToEdit(form.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                              <div v-if="(form.status === 'DRAFT' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="updateFormStatus(form.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                              <div v-if="(form.status === 'DRAFT' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu" @click="deleteFormConfirm(form.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                              <div v-if="form.status=='PUBLISH'" class="action-dd-menu"  @click="cloneForm(form.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                              <div v-if="(form.status=='PUBLISH' && (masterAdmin === true) && (!$store.state.switch_admin_username))" class="action-dd-menu"  @click="deactivateFormConfirm(form.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                              <div class="action-dd-menu" @click="previewForm(form.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                              <div class="action-dd-menu" @click="getListOfFormFields(form.id)"><i class="cursor-pointer fa fa-connectdevelop spacer-icon"></i>Map Form fields to PDF</div>
                            </div>
                            <div v-bind:id="'actionDropdown_' + index" class="dropdown-content" v-else>
                              <div v-if="form.status=='PUBLISH'" class="action-dd-menu"  @click="cloneForm(form.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                              <div class="action-dd-menu" @click="previewForm(form.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                            </div>
                          </div>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
                <div v-else class="text-center m-2 text-danger">
                    No Form Found
                </div>
                <div style="clear: both;"></div>
            </div>
        </div>
        <CreateFormModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading"><h3>Create Form</h3></div>
          <div slot="body" v-if="isModalVisible === true">
              <form v-on:submit.prevent="createForm()">
                <div class="col-12 override-padding">
                    <input v-model="form_name"
                        name="form_name"
                        placeholder="Enter Form Name"
                        class="col-lg-12 input-text form-control"
                        style="line-height: 30px "
                        v-validate="'required'"
                        maxlength="255" />
                    <div v-if="verrors.firstByRule('form_name', 'required')" class="margin-bottom-5 validate-warning-msg">Form name is required</div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>
                <div class="col-12 override-padding">
                    <div class="search-padd" id="mentee-group-wrapper">
                        <label class="font-weight-bold">Select User Type: </label>
                        <div v-for="(userType, index) in roles_options" :key="index" class="p-1 ml-2">
                            <input type="checkbox"
                            :value="userType.value"
                            v-bind:id="'usertype_'+index"
                            name="usertype"
                            v-model="usertypes_selected"
                            v-validate data-vv-rules="required" data-vv-as="User Type"
                            >
                            <label :for="'usertype_'+index">{{ userType.name }}</label>
                        </div>
                        <div v-if="verrors.firstByRule('usertype', 'required')" class="margin-bottom-5 validate-warning-msg">User Type is required</div>
                    </div>
                </div>
                <div style="clear: both;" class="margin-bottom-10"></div>
                <div class="col-12 override-padding text-align-right">
                    <button
                        type="submit"
                        class="btn btn-primary btn-sm fmAddBtn"
                    ><b>Create</b></button>
                </div>
              </form>
          </div>
          <div slot="footer" class="col-3 override-padding">

          </div>
        </CreateFormModal>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete the form?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteForm(id)">Confirm</button>
          </div>
        </DeleteModal>

        <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateForm(deactivateId)">Confirm</button>
          </div>
        </DeactivateModal>

        <!-- map form fields pdf modal start -->
        <MapFormFieldsPdfModalVisible :isModalVisible="isMapFormFieldsPdfModalVisible" :id="pdfFormId" @close="closeMapFormFieldsPdfModalVisible()">
            <span v-if="loading" class="pull-right text-danger">
            Loading...
            </span>
            <div slot="header" class="sub-heading"><h3>Map Form fields to PDF: {{ isInitial }} </h3></div>
            <div slot="body" v-if="isMapFormFieldsPdfModalVisible === true">
                <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving" @submit.prevent="saveFormFieldsToPdf(pdfFormId)">
                    <div class="row p-2" v-for="(field, fIndex) in assigned_fields_with_options.form_fields" :key="fIndex">
                      <div class="col-4">
                          <label>{{ field.field_name }}</label>
                      </div>
                      <div class="col-8" v-if="field.field_type == 'text'">
                        <input v-model="field.pdf_field_name"
                            v-bind:name="'field_pdf_name['+field.field_id+']'"
                            class="col-12 ma-input-field"
                            v-validate="'required'"
                            maxlength="75" />
                      </div>
                      <div style="clear: both;" class="margin-bottom-10"></div>
                      <div class="view_field_options row" v-for="(fieldVal, valIndex) in field.field_values" :key="valIndex">
                        <div class="col-4">
                            <label>{{ fieldVal.optionValue }}</label>
                        </div>
                        <div class="col-8">
                          <input v-model="fieldVal.pdf_field_option_values"
                              v-bind:name="'field_pdf_name['+field.field_id+']['+fieldVal.field_option_value_id+']'"
                              class="col-12 ma-input-field"
                              v-validate="'required'"
                              maxlength="75" />
                        </div>
                        <div v-if="verrors.firstByRule('field_pdf_name['+field.field_id+']['+fieldVal.field_option_value_id+']', 'required')" class="pdf_input_error margin-bottom-5 validate-warning-msg">PDF Field name is required for {{ fieldVal.optionValue }}</div>
                      </div>
                      <div v-if="verrors.firstByRule('field_pdf_name['+field.field_id+']', 'required') && field.field_values.length == 0" class="pdf_input_error margin-bottom-5 validate-warning-msg">PDF Field name is required for {{ field.field_name }} </div>
                    </div>
                    <div style="clear: both;" class="margin-bottom-10"></div>
                    <div class="col-lg-12 col-12 override-padding" v-if="!assigned_fields_with_options.pdf_filename || assigned_fields_with_options.is_pdf_remove">
                      <div class="dropbox">
                        <input 
                          type="file" 
                          name="pdf_file"
                          ref="pdf_file"
                          accept="type/pdf"
                          rules="required"
                          class="input-file">
                          <p v-if="isInitial">Drag your file here to begin<br> or click to browse</p>
                          <p v-if="isSaving"> Uploading file... </p>
                      </div>
                      <p v-if="uploadError" class="text-danger">{{uploadError}}</p>
                    </div>
                    <div class="col-lg-12 col-12 override-padding" v-else>
                      <div class="p-2">Uploaded PDF: 
                        <a :href="assigned_fields_with_options.pdf_full_path" target="_blank">{{ assigned_fields_with_options.pdf_filename}}</a>
                        <a @click="removeExistingPdf()" class="text-danger float-right">
                          <i class="cursor-pointer fa fa-times"></i>
                        </a>
                      </div>
                    </div>
                    
                    <div style="clear: both;" class="margin-bottom-10"></div>
                    <div class="col-12 override-padding text-align-right">
                        <button 
                            type="submit"
                            class="btn btn-primary btn-sm fmAddBtn"
                        ><b>Save</b></button>
                    </div>
                </form>
            </div>
            <div slot="footer" class="col-3 override-padding">

            </div>
        </MapFormFieldsPdfModalVisible>
        <!-- Map form fields pdf modal end -->

    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import { store } from '../../store/store';
import EventBus from '../../bus';
import moment from 'moment';
import router from '../../router/index.js';
import CreateFormModal from '../admin/create-tasklist-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import MapFormFieldsPdfModalVisible from '../admin/map_form_fields_pdf_modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

Vue.filter('formatFormUpdatedDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

export default {
      // props: ['accountId'],
      props: {
        accountId: {
          type: Number,
          default: 0,
        },
        isPathwayTab: {
          type: Boolean,
          default: false,
        }
      },
      data() {
        return {
          forms_selected: [],
          formslists: [],
          affiliate_selected: [],
          loading: false,
          isModalVisible: false,
          form_name: '',
          usertypes_selected: [],
          roles_options: [
            {
              name: 'Manager',
              value: 'ROLE_ADMIN',
            },
            {
              name: 'Mentor',
              value: 'ROLE_MENTOR',
            },
            {
              name: 'Mentee',
              value: 'ROLE_MENTEE',
            },
            {
              name: 'Apprentice',
              value: 'ROLE_APPRENTICE',
            },
          ],
          masterAdmin: false,
          isDeleteModalVisible: false,
          isDeactivateModalVisible: false,
          id: '',
          deactivateId: '',
          isSubmit: false,
          isMapFormFieldsPdfModalVisible: false,
          assigned_fields_with_options: [],
          form_fields: {
            pdf_field_name: []
          },
          uploadedFiles: [],
          uploadError: '',
          currentStatus: null,
          pdfFormId: '',
        }
      },
      components:{
        CreateFormModal,
        DeleteModal,
        DeactivateModal,
        MapFormFieldsPdfModalVisible,
      },
      computed: {
        isInitial() {
          return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
          return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
          return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
          return this.currentStatus === STATUS_FAILED;
        }
      },
      methods: {
        fetchFormsManager: function() {
            this.loading = true;
            let postData = {};
            if (this.accountId) {
              postData =  { accountId: this.accountId };
            }
            axios('/affiliate/forms-manager',
              {
                method: 'POST',
                data: postData,
              },
            )
            .then((resp) => {
                this.loading = false;
                this.formslists = resp.data.data;
                if (resp.data.forms_selected.length > 0) {
                  this.forms_selected = resp.data.forms_selected;
                } else {
                  this.forms_selected = [];
                }
            })
            .catch(error => {

            });
        },
	      toggleDropdown (id) {
          document.getElementById(id).classList.toggle("show");
          window.scrollTo(0,document.body.scrollHeight);
        },
        hideActionMenu(e) {
          var matches = document.getElementsByClassName('dropdown-content');
          for (var i=0; i<matches.length; i++) {
            var container = document.getElementById('dropdown-container-'+ i);

            if (!container.contains(e.target)) {
                if (document.getElementById('actionDropdown_' + i).classList.contains("show")) {
                    document.getElementById('actionDropdown_' + i).classList.remove('show');
                }
            }
          }
        },
        createForm: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.isSubmit = true;
              axios('/private-forms-manager',
                  {
                    method: 'POST',
                    data:
                    {
                      name: this.form_name,
                      usertypes_selected: this.usertypes_selected,
                      accountId: this.accountId,
                    },
                  }
                )
              .then((resp) => {
                this.isSubmit = false;
                this.flash({ message: 'Form has been created successfully.', variant: 'success' });
                const form_id = resp.data.id;
                let page_url = this.$route.fullPath;
                let active_tab = 'PathwayTab';
                let active_sub_tab = 'FormsTab';
                store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
                router.push('/add-form-custom-fields/' + form_id);
              })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
                const fieldErrors =  [];
                var errMsgObj = error.response.data.message;
                Object.keys(errMsgObj).map(key => {
                  var newFieldErr = {field:key, msg:errMsgObj[key], rule:'exists'};
                  fieldErrors.push(newFieldErr);
                });
                this.$validator.errors.add(fieldErrors);
              });
            }
          })
          .catch(() => {

          });

        },
        cloneForm: function(form_id) {
          this.loading = true;
          axios('/clone-form-manager/' + form_id,
            {
              method: 'POST',
              data: {
                accountId: this.accountId,
              }
            }
          )
          .then((resp) => {
            this.loading = false;
            this.flash({ message: 'Form has been cloned successfully.', variant: 'success' });
            let page_url = this.$route.fullPath;
            let active_tab = 'PathwayTab';
            let active_sub_tab = 'FormsTab';
            store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
            router.push("/add-form-custom-fields/" + resp.data);
          })
          .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
          });
        },
        goToEdit: function(form_id) {
          let page_url = this.$route.fullPath;
          let active_tab = 'PathwayTab';
          let active_sub_tab = 'FormsTab';
          store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
          router.push("/add-form-custom-fields/" + form_id);
        },
        updateFormStatus: function(form_id, status_text) {
          this.loading = true;
          axios('/private-forms-manager/' + form_id,
            {
              method: 'PATCH',
              data: { "status": status_text, "accountId": this.accountId },
            }
          )
          .then((resp) => {
            this.loading = false;
            let page_url = this.$route.fullPath;
            let active_tab = 'PathwayTab';
            let active_sub_tab = 'FormsTab';
            store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
            this.flash({ message: 'Form has been updated successfully.', variant: 'success' });
            router.go(this.$route.fullPath);
          })
          .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
          });
        },
        deleteFormConfirm: function(form_id) {
          this.isDeleteModalVisible = true;
          this.id = form_id;
        },
        deleteForm: function(form_id) {
          this.isDeleteModalVisible = false;
          this.loading = true;
          axios('/forms-manager/' + form_id,
              {
                method: 'DELETE',
              }
            )
          .then((resp) => {
              this.loading = false;
              let page_url = this.$route.fullPath;
              let active_tab = 'PathwayTab';
              let active_sub_tab = 'FormsTab';
              store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
              this.flash({ message: 'Form has been deleted successfully.', variant: 'success' });
              router.go(this.$route.fullPath);
            })
          .catch(error => {

          });
        },
        deactivateFormConfirm: function(form_id) {
          this.isDeactivateModalVisible = true;
          this.deactivateId = form_id;
        },
        deactivateForm(form_id) {
          this.isDeactivateModalVisible = false;
          this.loading = true;
          axios('/forms-manager/' + form_id,
            {
              method: 'PATCH',
              data: { "status": 'DEACTIVATED'},
            }
          )
          .then((resp) => {
            this.loading = false;
            let page_url = this.$route.fullPath;
            let active_tab = 'PathwayTab';
            let active_sub_tab = 'FormsTab';
            store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
            this.flash({ message: 'Form has been deactivated successfully.', variant: 'success' });
            router.go(this.$route.fullPath);
          })
          .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
          });
        },
        previewForm: function (form_id) {
          let page_url = this.$route.fullPath;
          let active_tab = 'PathwayTab';
          let active_sub_tab = 'FormsTab';
          store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
          router.push('/display-fill-form/' + form_id);
        },
        closeMapFormFieldsPdfModalVisible() {
          this.isMapFormFieldsPdfModalVisible = false;
        },
        getListOfFormFields(formId) {
          axios.get('/get-assigend-form-fields-with-options/' + formId)
          .then((resp) => {
            this.assigned_fields_with_options = resp.data;
            this.isMapFormFieldsPdfModalVisible = true;
            this.pdfFormId = formId;
          })
          .catch(error => {
          });
        },
        resetUpload() {
          // reset form to initial state
          this.currentStatus = STATUS_INITIAL;
          this.uploadedFiles = [];
          this.uploadError = null;
        },
        saveFormFieldsToPdf(formId) {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              // handle file changes
              this.uploadError = '';
              const pdfData = new FormData();

              var validateFile = false;
              if (!this.assigned_fields_with_options.pdf_filename) {
                validateFile = true;
              } else {
                if (!this.assigned_fields_with_options.is_pdf_remove) {
                  validateFile = false;
                } else {
                  validateFile = true;
                }
              }
              if (validateFile) {
                if (!this.$refs.pdf_file.files.length) {
                  this.uploadError = 'Upload PDF file'
                  return
                }

                if(this.$refs.pdf_file.files[0].type !== "application/pdf") {
                  this.uploadError = 'Upload PDF file only'
                  return
                }

                pdfData.append("pdf_file", this.$refs.pdf_file.files[0], this.$refs.pdf_file.files[0].name);
              }

              var is_pdf_remove = 0;
              if (this.assigned_fields_with_options.is_pdf_remove) {
                is_pdf_remove = 1;
              }

              // append the files to FormData
              pdfData.append("pdf_field_names", JSON.stringify(this.assigned_fields_with_options));
              pdfData.append("form_id", formId);
              pdfData.append("is_pdf_remove", is_pdf_remove);
              pdfData.append("old_pdf_filename", this.assigned_fields_with_options.pdf_filename);
              
              // console.log(pdfData)
              
              // upload data to the server
              this.currentStatus = STATUS_SAVING;

              axios.post('/upload-pdf-form-fields-mapping', pdfData, {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'application/pdf',
                    'Content-Type': 'multipart/form-data'
                  },
              })
              .then(resp => {
                this.flash({ message: "The Pdf file has been uploaded successfully.", variant: 'success' });
                this.currentStatus = STATUS_SUCCESS;
                this.isMapFormFieldsPdfModalVisible = false;
                this.resetUpload();
                this.fetchFormsManager();
              })
              .catch(error => {
                this.uploadError = error.response.data.message;
                this.currentStatus = STATUS_FAILED;
              })
            }
          });
        },
        removeExistingPdf() {
          this.assigned_fields_with_options.is_pdf_remove = true;
        }
      },
      mounted() {
        document.addEventListener('click', this.hideActionMenu);
        this.resetUpload();
      },
      beforeDestroy() {
        document.removeEventListener('click', this.hideActionMenu);
      },
      created: function () {
        if (store.state.search_parameters) {
          this.forms_selected = store.state.search_parameters.search_form.forms_selected;
        }
        if (store.state.search_enterprise_parameters) {
          this.forms_selected = store.state.search_enterprise_parameters.search_form.forms_selected;
        }
        this.fetchFormsManager();
        var roles = store.state.roles;
        if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          this.masterAdmin = true;
        }
      },
    }
</script>
<style scoped>
.ea_title { margin-left: 1rem; }
.ea_name { margin-left: 3rem; }
.enterprise_header { width: 100%; }
.enterprise_heading_1 { width: 10%; }
.enterprise_heading_2 { width: 30%; }
.enterprise_heading_3 { width: 10%; }
.enterprise_heading_4 { width: 40%; }
.enterprise_heading_5 { width: 10%; }
.enterprise_accounts_header {
  background: #00ACEE none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.view_enterprise_accounts:nth-child(odd) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #e9e9e9 !important;
  color: #707070;
}
.view_enterprise_accounts:nth-child(even) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #FFFFFF !important;
  color: #707070;
}
.form_heading_4 {
  width: 50%;
}
.account-lookup-view-list .tasklist-item {
    padding: 3px 0px;
}
.fmAddBtn {
    color: #FFF;
    background-color: #00acee;
    border: 1px solid #00acee;
    padding: 8px !important;
    font-size: 13px;
    font-weight: 900;
    float: right;
}
.fmAddBtn:focus, .fmAddBtn:active {
    color: #FFF !important;
    background-color: #00acee !important;
    border: 1px solid #00acee !important;
}
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
/* Upload Form CSS Start */
.view-fields-scroll {
  height: 300px;
  margin: 0 auto;
  overflow-y: scroll;
}
.view_field_options {
  width: 100%;
  margin: 5px 10px 5px 10px;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
.pdf_input_error  {
  width: 98%;
  text-align: right;
}
input.ma-input-field {
  border-width: 1px;
  border-style: inset;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_forms_tab.vue